package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.List
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import br.com.htms.inspeccaocampo.ui.kit.LinhaOpcoes
import br.com.htms.inspeccaocampo.ui.kit.TituloSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.checklist.AxiaRequisitosMev
import br.com.htms.inspeccaocampo.data.checklist.ChecklistDiarioMarca
import br.com.htms.inspeccaocampo.data.RespostaConformidade
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.CampoFotoRow
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.shared.ui.components.ItemConformidadeCard
import br.com.htms.inspeccaocampo.shared.ui.components.LegendaConformidade
import br.com.htms.inspeccaocampo.shared.ui.components.PersonNameAutocompleteField
import br.com.htms.inspeccaocampo.shared.ui.components.PreviaAntesSalvarDialog
import br.com.htms.inspeccaocampo.shared.ui.components.SharedFotosMenu
import br.com.htms.inspeccaocampo.shared.ui.components.SignatureField
import br.com.htms.inspeccaocampo.shared.ui.components.SignaturePadScreen
import br.com.htms.inspeccaocampo.ui.FormPrevia
import kotlinx.coroutines.launch

private val AxiaObsWarningRed = Color(0xFFC62828)

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedChecklistDiarioScreen(controller: AppController) {
    val form by controller.checklistDiarioForm.collectAsState()
    val erros by controller.erros.collectAsState()
    val mensagem by controller.mensagem.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()
    val assinaturaEditando by controller.assinaturaEditando.collectAsState()
    val capturandoGps by controller.capturandoGps.collectAsState()
    val formTipoAtivo by controller.formTipoAtivo.collectAsState()
    val appConfig by controller.appConfig.collectAsState()

    val snackbar = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()
    val listState = rememberLazyListState()
    var menuObraAberto by remember { mutableStateOf(false) }
    var mostrarPrevia by remember { mutableStateOf(false) }
    var listaFotosPlano by remember { mutableStateOf(false) }
    var listaFotosEvidencias by remember { mutableStateOf(false) }
    var listaFotosCrlv by remember { mutableStateOf(false) }

    fun scrollSeguro(index: Int) {
        scope.launch {
            val total = listState.layoutInfo.totalItemsCount
            if (total > 0) runCatching { listState.animateScrollToItem(index.coerceIn(0, total - 1)) }
        }
    }

    val marca = remember(form.marca, formTipoAtivo) {
        form.marcaEnum().takeIf { it.formTipo() == formTipoAtivo }
            ?: ChecklistDiarioMarca.fromFormTipo(formTipoAtivo)
    }
    val tipos = remember(marca) { marca.tipos() }

    LaunchedEffect(Unit) {
        controller.carregarObrasAtivas()
    }

    LaunchedEffect(mensagem) {
        val msg = mensagem ?: return@LaunchedEffect
        snackbar.showSnackbar(msg)
        controller.consumirMensagem()
    }

    // Erros ficam num card fixo no rodapé — não precisa rolar a lista até eles.

    if (assinaturaEditando != null) {
        val campo = assinaturaEditando!!
        val titulo = when (campo) {
            "cd_motorista" -> if (marca == ChecklistDiarioMarca.AXIA) {
                "Assinatura do responsável pela vistoria"
            } else {
                "Assinatura — Motorista"
            }
            "cd_encarregado" -> "Assinatura — Encarregado"
            "cd_sesmt" -> "Assinatura — SESMT"
            else -> "Assinatura"
        }
        SignaturePadScreen(
            titulo = titulo,
            onCancelar = { controller.fecharAssinatura() },
            onConfirmar = { token ->
                val key = when (campo) {
                    "cd_motorista" -> "motorista"
                    "cd_encarregado" -> "encarregado"
                    "cd_sesmt" -> "sesmt"
                    else -> campo
                }
                controller.salvarAssinaturaChecklistDiario(key, token)
            }
        )
        return
    }

    if (form.tipoId.isBlank()) {
        PortalModulo(
            titulo = marca.titulo,
            itens = tipos.map { PortalMenuItem(it.id, it.nome, Icons.Filled.List) },
            selecionado = "",
            onSelect = { id ->
                tipos.firstOrNull { it.id == id }?.let { controller.selecionarTipoChecklistDiario(it) }
            }
        ) { _ ->
            Text(
                "Selecione o tipo de inspeção no menu. Cada tipo abre o checklist correspondente.",
                color = PortalCores.CinzaTexto
            )
            if (marca == ChecklistDiarioMarca.AXIA) {
                AxiaRequisitosBanner(tipoNome = "")
            }
            tipos.forEach { tipo ->
                br.com.htms.inspeccaocampo.ui.kit.CartaoSecao(tipo.nome, subtitulo = "${tipo.itens.size} itens") {
                    PortalButton(
                        onClick = { controller.selecionarTipoChecklistDiario(tipo) },
                        modifier = Modifier.fillMaxWidth()
                    ) { Text("Abrir") }
                }
            }
        }
        return
    }

    val coordsTexto = when {
        form.latitude != null && form.longitude != null ->
            "Lat: ${form.latitude}  Lng: ${form.longitude}"
        else -> ""
    }

    Scaffold(snackbarHost = { SnackbarHost(snackbar) }) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .background(Color.Transparent)
        ) {
            br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(listState, Modifier.fillMaxSize()) {
            LazyColumn(
                state = listState,
                modifier = Modifier.fillMaxSize(),
                contentPadding = PaddingValues(
                    start = 16.dp,
                    top = 16.dp,
                    end = 16.dp,
                    bottom = if (erros.isNotEmpty()) 220.dp else 96.dp
                ),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                item {
                    PortalOutlinedButton(
                        onClick = { controller.voltarAoHub() },
                        modifier = Modifier.fillMaxWidth()
                    ) { Text("Voltar ao hub") }
                }

                item {
                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Column(Modifier.fillMaxWidth(0.72f)) {
                            Text(
                                form.tipoNome.ifBlank { marca.titulo },
                                style = MaterialTheme.typography.titleMedium,
                                fontWeight = FontWeight.Bold,
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis
                            )
                            Text(
                                "LEGENDA: C / NC / NA",
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                        PortalOutlinedButton(onClick = { controller.limparTipoChecklistDiario() }) {
                            Text("Trocar tipo")
                        }
                    }
                    LegendaConformidade()
                }

                if (marca == ChecklistDiarioMarca.AXIA) {
                    item {
                        AxiaRequisitosBanner(tipoNome = form.tipoNome)
                    }
                    item {
                        TituloSecao("Documentos obrigatórios (MEV)")
                        Text(
                            if (AxiaRequisitosMev.exigeCrlv(form.tipoNome)) {
                                "Anexe fotos ou documentos do plano de manutenção, das evidências " +
                                    "e do CRLV (impresso ou eletrônico)."
                            } else {
                                "Anexe fotos ou documentos do plano de manutenção e das evidências de realização."
                            },
                            style = MaterialTheme.typography.bodySmall,
                            modifier = Modifier.padding(bottom = 4.dp)
                        )
                        CampoFotoRow(
                            label = "Plano de manutenção",
                            obrigatorio = true,
                            quantidadeFotos = form.fotosPlanoManutencao.size,
                            onTirarFoto = { controller.adicionarFotoDocumentoAxia("plano") },
                            onAdicionarMais = { controller.adicionarFotoDocumentoAxia("plano") },
                            onAbrirLista = { listaFotosPlano = true },
                            onGaleria = {
                                controller.adicionarFotoDocumentoAxia("plano", fromGallery = true)
                            }
                        )
                        controller.erroNoCampo("fotosPlanoManutencao")?.let { msg ->
                            Text(
                                msg,
                                color = MaterialTheme.colorScheme.error,
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                        CampoFotoRow(
                            label = "Evidências de manutenção",
                            obrigatorio = true,
                            quantidadeFotos = form.fotosEvidenciasManutencao.size,
                            onTirarFoto = { controller.adicionarFotoDocumentoAxia("evidencias") },
                            onAdicionarMais = { controller.adicionarFotoDocumentoAxia("evidencias") },
                            onAbrirLista = { listaFotosEvidencias = true },
                            onGaleria = {
                                controller.adicionarFotoDocumentoAxia(
                                    "evidencias",
                                    fromGallery = true
                                )
                            }
                        )
                        controller.erroNoCampo("fotosEvidenciasManutencao")?.let { msg ->
                            Text(
                                msg,
                                color = MaterialTheme.colorScheme.error,
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                        if (AxiaRequisitosMev.exigeCrlv(form.tipoNome)) {
                            CampoFotoRow(
                                label = AxiaRequisitosMev.DOC_CRLV_ROTULO,
                                obrigatorio = true,
                                quantidadeFotos = form.fotosCrlv.size,
                                onTirarFoto = { controller.adicionarFotoDocumentoAxia("crlv") },
                                onAdicionarMais = { controller.adicionarFotoDocumentoAxia("crlv") },
                                onAbrirLista = { listaFotosCrlv = true },
                                onGaleria = {
                                    controller.adicionarFotoDocumentoAxia(
                                        "crlv",
                                        fromGallery = true
                                    )
                                }
                            )
                            controller.erroNoCampo("fotosCrlv")?.let { msg ->
                                Text(
                                    msg,
                                    color = MaterialTheme.colorScheme.error,
                                    style = MaterialTheme.typography.bodySmall
                                )
                            }
                        }
                    }
                }

                item {
                    TituloSecao("Dados gerais")
                    br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                        label = "Obra *",
                        opcoes = obrasAtivas.map { it.nome to it.nome },
                        selecionado = form.obra,
                        onSelect = { v -> controller.atualizarChecklistDiario { it.copy(obra = v) } },
                        isError = controller.erroNoCampo("obra") != null,
                        supportingText = controller.erroNoCampo("obra")?.let { { Text(it) } }
                    )
                    PersonNameAutocompleteField(
                        value = form.preenchidoPor,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(preenchidoPor = v) }
                        },
                        label = "Preenchido por *",
                        isError = controller.erroNoCampo("preenchidoPor") != null,
                        supportingText = controller.erroNoCampo("preenchidoPor")?.let { { Text(it) } },
                        formTipo = formTipoAtivo,
                        appConfig = appConfig
                    )
                    if (marca == ChecklistDiarioMarca.AXIA) {
                        AppOutlinedTextField(
                            value = form.fornecedorCliente,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(fornecedorCliente = v) }
                            },
                            label = { Text("Fornecedor/Cliente") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppOutlinedTextField(
                            value = form.contrato,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(contrato = v) }
                            },
                            label = { Text("Contrato") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppDateTextField(
                            value = form.validadeContrato,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(validadeContrato = v) }
                            },
                            label = "Validade do contrato",
                            kind = DateFieldKind.DATE,
                            isError = controller.erroNoCampo("validadeContrato") != null,
                            supportingText = controller.erroNoCampo("validadeContrato")?.let { { Text(it) } }
                        )
                        AppOutlinedTextField(
                            value = form.gestorContrato,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(gestorContrato = v) }
                            },
                            label = { Text("Gestor do contrato") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppOutlinedTextField(
                            value = form.localidadeMobilizacao,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(localidadeMobilizacao = v) }
                            },
                            label = { Text("Localidade de mobilização") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppOutlinedTextField(
                            value = form.areaAcesso,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(areaAcesso = v) }
                            },
                            label = { Text("Área de acesso") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppDateTextField(
                            value = form.anoFabricacao,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(anoFabricacao = v) }
                            },
                            label = "Ano de fabricação",
                            kind = DateFieldKind.YEAR,
                            isError = controller.erroNoCampo("anoFabricacao") != null,
                            supportingText = controller.erroNoCampo("anoFabricacao")?.let { { Text(it) } }
                        )
                        AppOutlinedTextField(
                            value = form.tipoVeiculo,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(tipoVeiculo = v) }
                            },
                            label = { Text("Tipo de veículo") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                    } else {
                        AppOutlinedTextField(
                            value = form.numeroChecklist,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(numeroChecklist = v) }
                            },
                            label = { Text("Nº de Check List") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppDateTextField(
                            value = form.mesAno,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(mesAno = v) }
                            },
                            label = "Mês/Ano",
                            kind = DateFieldKind.MONTH_YEAR,
                            isError = controller.erroNoCampo("mesAno") != null,
                            supportingText = controller.erroNoCampo("mesAno")?.let { { Text(it) } }
                        )
                    }
                    AppOutlinedTextField(
                        value = form.proprietario,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(proprietario = v) }
                        },
                        label = { Text("Proprietário") },
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    AppOutlinedTextField(
                        value = form.modelo,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(modelo = v) }
                        },
                        label = { Text("Modelo") },
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    AppOutlinedTextField(
                        value = form.placa,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(placa = v) }
                        },
                        label = { Text("Placa/Identificação") },
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    if (marca == ChecklistDiarioMarca.HTMS) {
                        AppOutlinedTextField(
                            value = form.combustivel,
                            onValueChange = { v ->
                                controller.atualizarChecklistDiario { it.copy(combustivel = v) }
                            },
                            label = { Text("Combustível") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                    }
                    AppOutlinedTextField(
                        value = form.motoristaNome,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(motoristaNome = v) }
                        },
                        label = { Text(if (marca == ChecklistDiarioMarca.AXIA) "Motorista / Operador" else "Motorista") },
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    AppOutlinedTextField(
                        value = form.motoristaFuncao,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(motoristaFuncao = v) }
                        },
                        label = { Text("Função") },
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    AppOutlinedTextField(
                        value = form.motoristaCnh,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(motoristaCnh = v) }
                        },
                        label = { Text("CNH/Curso") },
                        modifier = Modifier.fillMaxWidth(),
                        colors = FormFieldDefaults.textFieldColors()
                    )
                    AppDateTextField(
                        value = form.motoristaValidade,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(motoristaValidade = v) }
                        },
                        label = "Validade CNH",
                        kind = DateFieldKind.DATE,
                        isError = controller.erroNoCampo("motoristaValidade") != null,
                        supportingText = controller.erroNoCampo("motoristaValidade")?.let { { Text(it) } }
                    )
                }

                item {
                    TituloSecao("Localização (GPS)")
                    if (coordsTexto.isNotBlank()) {
                        Text(coordsTexto, style = MaterialTheme.typography.bodySmall)
                    }
                    if (form.localTexto.isNotBlank()) {
                        Text(form.localTexto, style = MaterialTheme.typography.bodyMedium)
                    }
                    controller.erroNoCampo("localGps")?.let {
                        Text(it, color = MaterialTheme.colorScheme.error)
                    }
                    PortalOutlinedButton(
                        onClick = { controller.capturarGpsChecklistDiario() },
                        enabled = !capturandoGps,
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        ButtonLoadingContent(
                            loading = capturandoGps,
                            loadingText = "Capturando…",
                            idleText = if (form.latitude != null) "Atualizar GPS" else "Capturar GPS"
                        )
                    }
                }

                item {
                    TituloSecao("Itens de verificação")
                }

                items(form.itens, key = { it.id }) { item ->
                    ItemConformidadeCard(
                        item = item,
                        erro = controller.erroNoCampo(item.id),
                        onResposta = { controller.definirRespostaChecklistDiario(item.id, it) },
                        onJustificativa = { j ->
                            controller.atualizarItemChecklistDiario(item.id) { it.copy(justificativa = j) }
                        },
                        onTirarFoto = { controller.adicionarFotoChecklistDiario(item.id) },
                        onAdicionarMaisFoto = { controller.adicionarFotoChecklistDiario(item.id) },
                        onRemoverFoto = { foto ->
                            controller.removerFotoChecklistDiario(item.id, foto)
                        },
                        onGaleria = {
                            controller.adicionarFotoChecklistDiario(item.id, fromGallery = true)
                        },
                        modifier = Modifier.fillMaxWidth()
                    )
                }

                item {
                    AppOutlinedTextField(
                        value = form.observacoesGerais,
                        onValueChange = { v ->
                            controller.atualizarChecklistDiario { it.copy(observacoesGerais = v) }
                        },
                        label = { Text("Observações gerais") },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 3,
                        colors = FormFieldDefaults.textFieldColors()
                    )
                }

                if (marca == ChecklistDiarioMarca.AXIA) {
                    item {
                        TituloSecao("Resultado da vistoria")
                        LinhaOpcoes(
                            opcoes = listOf(true, false),
                            selecionada = form.aprovado,
                            rotulo = { if (it) "Aprovado" else "Reprovado" },
                            cor = { if (it) PortalCores.Verde else PortalCores.Vermelho },
                            onSelect = { v -> controller.atualizarChecklistDiario { it.copy(aprovado = v) } },
                            modifier = Modifier.padding(top = 8.dp)
                        )
                        controller.erroNoCampo("aprovado")?.let { msg ->
                            Text(
                                msg,
                                color = MaterialTheme.colorScheme.error,
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                    }
                }

                item {
                    if (marca == ChecklistDiarioMarca.AXIA) {
                        TituloSecao("Observações e assinatura")
                        SignatureField(
                            label = "Assinatura do responsável pela vistoria",
                            assinaturaToken = form.assinaturaMotorista,
                            erro = controller.erroNoCampo("assinaturaMotorista"),
                            onClick = { controller.abrirAssinatura("cd_motorista") }
                        )
                    } else {
                        TituloSecao("Assinaturas")
                        SignatureField(
                            label = "Motorista",
                            assinaturaToken = form.assinaturaMotorista,
                            erro = null,
                            onClick = { controller.abrirAssinatura("cd_motorista") }
                        )
                        SignatureField(
                            label = "Encarregado",
                            assinaturaToken = form.assinaturaEncarregado,
                            erro = null,
                            onClick = { controller.abrirAssinatura("cd_encarregado") }
                        )
                        SignatureField(
                            label = "SESMT",
                            assinaturaToken = form.assinaturaSesmt,
                            erro = null,
                            onClick = { controller.abrirAssinatura("cd_sesmt") }
                        )
                    }
                }

                item {
                    PortalButton(
                        onClick = { mostrarPrevia = true },
                        modifier = Modifier.fillMaxWidth()
                    ) { Text("Prévia e salvar") }
                }
            }
            }

            // Card de erros fixo no rodapé do formulário (não no meio da lista).
            if (erros.isNotEmpty()) {
                Card(
                    modifier = Modifier
                        .align(Alignment.BottomCenter)
                        .fillMaxWidth()
                        .padding(start = 12.dp, end = 72.dp, bottom = 12.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = MaterialTheme.colorScheme.errorContainer
                    )
                ) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(6.dp)
                    ) {
                        Text("Corrija os campos obrigatórios:", fontWeight = FontWeight.Bold)
                        Text(
                            "Toque em um item para ir ao início.",
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onErrorContainer.copy(alpha = 0.8f)
                        )
                        erros.take(5).forEach { erro ->
                            Text(
                                text = "• ${erro.mensagem}",
                                color = MaterialTheme.colorScheme.onErrorContainer,
                                textDecoration = TextDecoration.Underline,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clickable { scrollSeguro(0) }
                                    .padding(vertical = 4.dp)
                            )
                        }
                        if (erros.size > 5) {
                            Text("... e mais ${erros.size - 5}")
                        }
                    }
                }
            }

            Column(
                modifier = Modifier
                    .align(Alignment.BottomEnd)
                    .padding(end = 12.dp, bottom = 12.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                FloatingActionButton(
                    onClick = { scrollSeguro(0) },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) {
                    Text("Início", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall)
                }
                FloatingActionButton(
                    onClick = {
                        val last = (listState.layoutInfo.totalItemsCount - 1).coerceAtLeast(0)
                        scrollSeguro(last)
                    },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) {
                    Text("Fim", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall)
                }
            }
        }
    }

    if (mostrarPrevia) {
        PreviaAntesSalvarDialog(
            linhas = FormPrevia.checklistDiario(form),
            onDismiss = { mostrarPrevia = false },
            onConfirmar = {
                mostrarPrevia = false
                controller.validarESalvarChecklistDiario()
            }
        )
    }

    if (listaFotosPlano) {
        SharedFotosMenu(
            titulo = "Plano de manutenção — fotos",
            fotos = form.fotosPlanoManutencao,
            aberto = true,
            onFechar = { listaFotosPlano = false },
            onRemover = { controller.removerFotoDocumentoAxia("plano", it) }
        )
    }
    if (listaFotosEvidencias) {
        SharedFotosMenu(
            titulo = "Evidências de manutenção — fotos",
            fotos = form.fotosEvidenciasManutencao,
            aberto = true,
            onFechar = { listaFotosEvidencias = false },
            onRemover = { controller.removerFotoDocumentoAxia("evidencias", it) }
        )
    }
    if (listaFotosCrlv) {
        SharedFotosMenu(
            titulo = "${AxiaRequisitosMev.DOC_CRLV_ROTULO} — fotos",
            fotos = form.fotosCrlv,
            aberto = true,
            onFechar = { listaFotosCrlv = false },
            onRemover = { controller.removerFotoDocumentoAxia("crlv", it) }
        )
    }
}

@Composable
private fun AxiaRequisitosBanner(tipoNome: String) {
    val mostraCrlv = tipoNome.isBlank() || AxiaRequisitosMev.exigeCrlv(tipoNome)
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.55f)
        )
    ) {
        Column(
            Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(
                AxiaRequisitosMev.TITULO,
                fontWeight = FontWeight.Bold,
                style = MaterialTheme.typography.titleSmall,
                color = PortalCores.Navy
            )
            Text("DETALHES:", fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.bodySmall)
            Text(
                "• ${AxiaRequisitosMev.DETALHE_CL}",
                style = MaterialTheme.typography.bodySmall
            )
            if (mostraCrlv) {
                Text(
                    "• ${AxiaRequisitosMev.DETALHE_VEICULOS}",
                    color = AxiaObsWarningRed,
                    style = MaterialTheme.typography.bodySmall,
                    fontWeight = FontWeight.Medium
                )
            }
            if (tipoNome.isNotBlank()) {
                Text(
                    "Requisito obrigatório:",
                    fontWeight = FontWeight.SemiBold,
                    style = MaterialTheme.typography.bodySmall
                )
                Text(
                    AxiaRequisitosMev.requisitoParaTipo(tipoNome),
                    style = MaterialTheme.typography.bodySmall
                )
            }
            Text(
                "OBS 1: ${AxiaRequisitosMev.OBS1}",
                color = AxiaObsWarningRed,
                style = MaterialTheme.typography.bodySmall,
                fontWeight = FontWeight.Medium
            )
            Text(
                "OBS 2: ${AxiaRequisitosMev.OBS2}",
                color = AxiaObsWarningRed,
                style = MaterialTheme.typography.bodySmall,
                fontWeight = FontWeight.Medium
            )
        }
    }
}
